import { combineReducers } from "redux";
import form from "./form";
import status from "./status";
import ui from "./ui";

export default combineReducers({
  form,
  status,
  ui,
});
